import { type ElementType } from 'react';
import { cn } from '@/shared/utils';

type Props = {
  icon: ElementType | string;
  label?: ElementType | string;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
};

const LabeledIcon = ({
  icon: IconComponent,
  label: LabelComponent,
  className,
  iconClassName,
  labelClassName,
}: Props) => {
  return (
    <div
      className={cn(
        'bg-background border border-border rounded-full w-[4.8rem] h-[4.8rem] relative flex items-center justify-center',
        // typeof IconComponent === 'string' && 'bg-tertiary',
        className
      )}>
      {typeof IconComponent === 'string' ? (
        <img src={IconComponent} alt="icon" className={iconClassName} />
      ) : (
        <IconComponent className={cn('size-8', iconClassName)} />
      )}
      {LabelComponent && typeof LabelComponent === 'string' ? (
        <img
          src={LabelComponent}
          alt="label"
          className={cn(
            'w-[1.8rem] h-[1.8rem] absolute -bottom-1 -right-1',
            labelClassName
          )}
        />
      ) : (
        LabelComponent && (
          <LabelComponent
            className={cn(
              'w-[1.8rem] h-[1.8rem] absolute -bottom-1 -right-1',
              labelClassName
            )}
          />
        )
      )}
    </div>
  );
};

export { LabeledIcon };
